import { render, staticRenderFns } from "./Notas.vue?vue&type=template&id=3b33c286&"
import script from "./Notas.vue?vue&type=script&lang=js&"
export * from "./Notas.vue?vue&type=script&lang=js&"
import style0 from "./Notas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports